import { useStore } from '../contexts/StoreContext.es.js';

const useInjectDynamicLinks = (text) => {
  const { mappingWebsiteMenuHref } = useStore();
  const formatText = () => {
    if (!text)
      return;
    return text.replace(
      new RegExp('(?<start><a[^>]+data-page-id=)"(?<pageId>[a-zA-Z0-9]+)"(?<end>[^>]*>)', "g"),
      (string, start, pageId, end) => {
        const href = mappingWebsiteMenuHref[pageId];
        if (!href)
          return string;
        return `${start}"${pageId}" href="${href}"${end}`;
      }
    );
  };
  return {
    text: formatText()
  };
};

export { useInjectDynamicLinks };
